import { currentLocale, translate } from '../i18n';
import { useUi } from '../store/ui';
import { syncNow, useSync } from './engine';

/**
 * A sync the user asked for. Success is silent, the board and the dot already show it;
 * only what needs attention becomes a toast.
 */
export async function manualSync(): Promise<void> {
  await syncNow();
  const { phase } = useSync.getState();
  if (phase === 'offline') useUi.getState().showToast(translate(currentLocale(), 'sync.offline'));
  else if (phase === 'error') useUi.getState().showToast(translate(currentLocale(), 'sync.error'));
}
